export default "__VITE_ASSET__BXKP08c6__"